'use strict';

var m = angular.module('ui.utils.masks.us', [
	require('../helpers')
])
.directive('uiUsPhoneNumber', require('./phone/us-phone'));

module.exports = m.name;



//////////////////
// WEBPACK FOOTER
// ../~/angular-input-masks/src/us/us-masks.js
// module id = 51
// module chunks = 3